<template>
    <div class="card">
        <ul class="list-group">
            <li class="list-group-item list-group-item-action" v-for="cliente in clientes" v-if="clientes.length>0">
                <div>
                    <span class="m-0">
                        {{cliente.CODIGO_CLIENTE}} | {{cliente.DESCRIPCION}}
                    </span>
                    
                    <span class="float-right list-group-hover">
                        <div class="btn-group">
                            <a href="#" class="btn btn-table btn-sm" v-on:click.prevent="edit(cliente)">
                                <i class="material-icons">edit</i>
                            </a>

                            <a href="#" class="btn btn-table btn-sm" v-on:click.prevent="destroy(cliente.CODIGO_CLIENTE)">
                                <i class="material-icons">delete</i>
                            </a>
                        </div>
                    </span>
                </div>
                <div>
                    <p class="m-0">
                        <small class="badge badge-pill badge-dark">
                            {{cliente.BASE_DATOS}}
                        </small>          
                    </p>
                </div>
            </li>
            <li class="list-group-item" v-else>
                <empty-search icon="library_add" title="Agrega Usuarios." description="Para poder visualizar el listado de los Usuarios debes agregar uno nueva.">
                    <a href="#" class="btn btn-success" v-tooltip="'Agregar Usuario'"  data-toggle="tooltip" data-placement="bottom">
                        <i class="fa fa-plus"></i> Agregar Usuario
                    </a>
                </empty-search>
            </li>
        </ul>

        <div class="card-body" v-if="false">
            <h3 class="card-title text-muted">
                <i class="material-icons">contacts</i> Clientes Bases
                <div class="float-right">
                    <a href="/" v-tooltip="'Regresar al Dashboard'">
                        <i class="material-icons vertical-bottom text-primary">dashboard</i>
                    </a>
                </div>
            </h3>

            <table class="table table-bordered table-sm">
                <thead>
                    <tr>
                        <th class="text-center">Código</th>
                        <th class="text-center">Descripción</th>
                        <th class="text-center">Límite Usuario</th>
                        <th class="text-center">Base de Datos</th>
                        <th class="text-center">Paginación</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="cliente in clientes" v-if="!loadingClientes">
                        <th>{{cliente.CODIGO_CLIENTE}}</th>
                        <td>{{cliente.DESCRIPCION}}</td>
                        <td>{{cliente.LIMITE_USUARIOS}}</td>
                        <td>{{cliente.BASE_DATOS}}</td>
                        <td>{{cliente.PAGINACION}}</td>
                        <td class="text-center">
                            <a href="#" class="btn btn-warning btn-sm" v-on:click.prevent="edit(cliente)">
                                <i class="material-icons">edit</i>
                            </a>

                            <a href="#" class="btn btn-danger btn-sm" v-on:click.prevent="destroy(cliente.CODIGO_CLIENTE)">
                                <i class="material-icons">delete</i>
                            </a>
                        </td>
                    </tr>
                    <tr v-if="loadingClientes" class="text-center">
                       <td colspan="5">
                           Cargando...
                       </td>
                    </tr>
                </tbody>
            </table>
            <!--<data-tables url="api/clienteBases" :options="options" class="table table-striped table-bordered" style="width:100%">
                <thead>
                    <tr>
                        <th class="text-center">Código</th>
                        <th class="text-center">Descripción</th>
                        <th class="text-center">Límite Usuario</th>
                        <th class="text-center">Base de Datos</th>
                    </tr>
                </thead>
            </data-tables>-->

            <div class="fixed-action-btn">
                <a href="#" v-on:click.prevent="createClient()" class="btn btn-primary btn-floating btn-large" v-tooltip="'Agregar Cliente'">
                    <i class="material-icons">add</i>
                </a>
            </div>
        </div>

        <div class="modal fade" id="createClientModal" role="dialog" aria-labelledby="eventModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-body rounded-top border-bottom border-danger" style="background-image: url('https://materializecss.com/images/office.jpg');color: white;">
                        <h3>{{title}}</h3>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label for="descripcion">Descripción:</label>
                            <input type="text" class="form-control" name="descripcion" v-model="form.descripcion" max="100" placeholder="Descripción">
                        </div>

                        <div class="form-group">
                            <label for="descripcion">Límite Usuarios:</label>
                            <input type="number" class="form-control" name="limite_usuarios" v-model="form.limite_usuarios" max="100">
                        </div>

                        <div class="form-group">
                            <label for="descripcion">Base de datos:</label>
                            <input type="text" class="form-control" name="base_datos" v-model="form.base_datos" max="150">
                        </div>

                        <div class="form-group">
                            <label for="descripcion">
                                Número de registros por paginación:
                            </label>
                            <input type="number" class="form-control" name="paginacion" v-model="form.paginacion" min="0">
                        </div>
                        
                        <div class="form-group">
                            <button class="btn btn-success" v-on:click="saveCliente" :disabled="loading">
                                <i class="material-icons">save</i> Guardar
                            </button>

                            <button class="btn btn-light" v-on:click="cancelCliente">
                                Cancelar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>    
</template>

<script>
    export default {
        mounted: function() {
            this.getClients();
        },

        data(){
            return {
                clientes: [],
                loading: false,
                loadingClientes: false,
                title: 'Agregar Cliente',
                form: {
                    codigo_cliente: '',
                    descripcion: '',
                    limite_usuarios: 0,
                    base_datos: 'JESTRADA_CRM_',
                    paginacion: 0,
                },
                
                options: {
                    columns: [
                        {data: 'CODIGO_CLIENTE'},
                        {data: 'DESCRIPCION'},
                        {data: 'LIMITE_USUARIOS'},
                        {data: 'BASE_DATOS'},
                        {data: 'PAGINACION'}
                    ],
                    columnDefs: ''
                },
            };
        },

        methods: {
            getClients(){
                var url = 'api/clienteBases';
                this.loadingClientes = true;
                axios.get(url)
                .then(response => {
                    this.clientes = response.data;
                })
                .catch(error => {
                    console.log(error.response);
                }).then(()=>{
                    this.loadingClientes = false;
                });
            },

            edit(data){
                var url = 'api/clienteBases';
                this.title = 'Editar Cliente';

                this.form.codigo_cliente = data.CODIGO_CLIENTE;
                this.form.descripcion = data.DESCRIPCION;
                this.form.limite_usuarios = data.LIMITE_USUARIOS;
                this.form.base_datos = data.BASE_DATOS;
                this.form.paginacion = data.PAGINACION;

                $('#createClientModal').modal('show');
            },

            destroy(id){
                var url = 'api/clienteBases/'+id;
                var modules = this
                $.confirm({
                    title: '¿Estás seguro?',
                    content: '¡Ya no podrás recuperar esta información!',
                    theme: 'supervan', // 'material', 'bootstrap'
                    buttons: {
                        confirmar: function () {
                            axios.delete(url)
                                .then(response => {
                                    modules.getClients();
                                    modules.$toasted.show('Eliminado');
                                })
                                .catch(error => {
                                    modules.$toasted.show('Error al eliminar');
                                    console.log(error.response);
                                });
                        },
                        cancelar: function () {
                        },
                    }
                });
            },

            createClient(){
                this.cleanFields();
                $('#createClientModal').modal('show');
            },

            saveCliente() {
                if(this.title =='Agregar Cliente'){
                    this.persistClient(
                        'post', '/api/clienteBases',
                        this.form, '#createClientModal', 'Cliente Agregado', 'Error Agregando Cliente'
                    );
                }else{
                    var url = '/api/clienteBases/'+this.form.codigo_cliente;
                    this.persistClient(
                        'put', url,
                        this.form, '#createClientModal', 'Cliente Actualizado', 'Error Actualizando Cliente'
                    );
                }
                
            },

            cancelCliente(){
                this.cleanFields();
                $('#createClientModal').modal('hide');
            },

            cleanFields(){
                this.title = 'Agregar Cliente'
                this.form.codigo_cliente = ''
                this.form.descripcion =  '';
                this.form.limite_usuarios =  0;
                this.form.base_datos =  'JESTRADA_CRM_';
                this.form.paginacion = 0;
            },

            persistClient(method, uri, form, modal, messageSuccess, messageError) {
                form.errors = [];
                this.loading = true;
                axios[method](uri, form)
                    .then(response => {
                        $(modal).modal('hide');
                        this.$toasted.show(messageSuccess);
                        this.getClients();
                    })
                    .catch(error => {
                        console.log(error.response);
                        this.$toasted.show(messageError);
                        if (typeof error.response.data === 'object') {
                            form.errors = _.flatten(_.toArray(error.response.data));
                        } else {
                            form.errors = ['Something went wrong. Please try again.'];
                        }
                    }).then(()=>{
                        this.loading = false;
                    });
            },
        }  
    }
</script>